module.exports = __webpack_public_path__ + "static/media/codeSound.0a3d586d.mp3";